import React from "react";
import { useT } from "../../i18n/useT";
import "./externalwebview.scss";

const ExternalWebView = ({ page, onClose }) => {
  const t = useT("mmtUserList");
  if (!page?.url) return null;

  return (
    <section className="external-web-view" aria-label={page.title}>
      <header className="external-web-view-header">
        <button
          type="button"
          className="external-web-view-close"
          onClick={onClose}
          aria-label={t("close")}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M19 12H5m0 0l7-7m-7 7l7 7"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <strong>{page.title}</strong>
      </header>
      <iframe
        className="external-web-view-frame"
        src={page.url}
        title={page.title}
        referrerPolicy="strict-origin-when-cross-origin"
      />
    </section>
  );
};

export default ExternalWebView;
